module.exports = require("./../../_gen/starling/events/TouchPhase");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/events/TouchPhase.js
// module id = 188
// module chunks = 0